<template>
    <div class="service-bill-list">
        <!-- 服务账单 -->
        <ab-list-query :tabs='tabs' @handleTabs="handleTabs">
            <template #right>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-input
                            placeholder="对账单号"
                            v-model.trim="formSearch.numberLike"
                            clearable
                        >
                        </el-input>
                    </el-col>
                    <el-col :span="4">
                        <el-select placeholder="回款状态" v-model="formSearch.returnStatus" clearable>
                            <el-option
                                v-for="(option, idx) in options.returnStatus"
                                :key="idx"
                                :label="option.desc"
                                :value="option.value"
                            ></el-option>
                        </el-select>
                    </el-col>
                    <!-- <el-col :span="4">
                        <el-select   placeholder="发票类型" v-model="formSearch.bizType" clearable>
                            <el-option
                                v-for="(option, idx) in [{desc: '13%增值税专用发票', value: '01'}, {desc: '海关税票+6% 服务费发票', value: '02'}]"
                                :key="idx"
                                :label="option.desc"
                                :value="option.value"
                            ></el-option>
                        </el-select>
                    </el-col> -->
                    <el-col :span="4">
                        <ab-timeSearch
                            class="searchBox"
                            startSrc="对账周期起"
                            endSrc="对账周期止"
                            v-model="customsData"
                            @searchEvent="periodTimeChange"
                        ></ab-timeSearch>
                    </el-col>
                    <el-col :span="4" class="text-left">
                        <el-button @click="()=>{searchForm()}">搜索</el-button>
                        <el-button link class="btn-svg" @click="resetForm"><ab-svg name="qingchu"></ab-svg>清除</el-button>
                    </el-col>
                </el-row>
            </template>

            <template #toolbar>
                <el-button type="primary" @click="derive" :loading="btnLoading">导出</el-button>
                <el-button :loading="exportLoading" @click="exportFile" :disabled="selectList.length !== 1">打印对账单</el-button>
            </template>

            <template #table>
                <ab-table
                    class="materialTable"
                    ref="table"
                    stripe
                    showEdit
                    showSelection
                    selectionWidth="45"
                    indexWidth="50"
                    widths="100"
                    isFilter="operator"
                    :filterArry="['到期时间', '账期类型']"
                    :column-list="columns"
                    :table-list="tableData"
                    :dataListLoading="isloading"
                    @filterColumns="filterColumns"
                    :handleSelectionChange="selectionChange"
                >
                    <template #number="props">
                        <span class="number-primary" @click="getDetail(props.row)">{{ props.row.number }}</span>
                    </template>

                    <template #operator='scope'>
                        <el-button type="primary" link @click="getDetail(scope.row)">详情</el-button>
                    </template>
                
                    <template #returnStatusDesc='scope'>
                            <div>
                                <span :class="getStatusClass(scope.row.returnStatusDesc)"></span>
                                {{ scope.row.returnStatusDesc }}
                            </div>
                    </template>

                    <template #isRead='scope'>
                        <div>
                            <span :class="getStatusClass(scope.row.isRead)"></span>
                            {{ scope.row.isRead == 0? '未读': '已读' }}
                        </div>
                    </template>
                </ab-table>
                
            </template>

            <template #page>
                <ab-page
                    :pageTotal="pages.total" 
                    :currentPage='pages.currentPage' 
                    :pageSize="pages.pageSize" 
                    :pageSizes="pages.pageSizes"
                    @searchForm="searchForm"
                ></ab-page>
            </template>
        </ab-list-query>
    </div>
</template>

<script>
export default {
    data() {
        return {
            btnLoading: false,
            isloading: false,
            options: {},
            formSearch:{},
            customsData: [],
            tabs: [
                {name: '全部', value: '', state: ''},
                {name: '未读', value: '', state: '0'},
                {name: '已读', value: '', state: '1'},
            ],
            columns: [
                {
                    props: 'number',
                    labels: '对账单号',
                    widths: 150, 
                    slot:'slot'
                },
                {
                    props: 'expireDateMin',
                    labels: '到期时间',
                    widths: 120
                },
                {
                    props: 'returnStatusDesc',
                    labels: '回款状态',
                    widths: 120, 
                    slot:'slot'
                },
                {
                    props: 'isRead',
                    labels: '查阅状态',
                    widths: 120,
                    slot:'slot'
                },
                {
                    props: 'dateInterval2',
                    labels: '对账周期',
                    widths: 200,
                },
                {
                    props: 'agreedWayDesc',
                    labels: '账期类型',
                    widths: 80
                },
                {
                    props: 'settleAmountStr',
                    labels: '应付金额',
                    widths: 130,                
                    align:'right' 
                },
                {
                    props: 'invoiceTaxPercent',
                    labels: '发票税率',
                    widths: 100,
                },
                /* {
                    props: 'settleCustomerIdDescipalIdDesc',
                    labels: '客户名称',
                    widths: 130,
                },
                {
                    props: 'settleCompanyIdDesc',
                    labels: '结算公司',
                    widths: 200,
                }, */

                {
                    props: 'remark',
                    labels: '备注',
                    widths: 120,
                },
            ],
            //选择列表
            selectList: [],
            exportLoading: false,
            tableData: [],
            pages: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0
            },
        }
    },
    created() {
        this.searchForm()
        this.getChange()
    },
    methods: {
        handleTabs(val){
            this.formSearch.isRead = val
            this.searchForm()
        },
        //筛选列表字段
        filterColumns(array) {
            this.columns = array;
        },
        getStatusClass(val) {
            let cls = "";
            switch (val) {
                case "待回款":
                case "未回款":
                    cls = "status-13227A";
                break;
                case "部分回款":
                    cls = "status-FF8400";
                break;
                case "已回款":
                    cls = "status-0AB2A8";
                break;
                case "已逾期":
                    cls = "status-E21010";
                break;
                case "待确认":
                case "待客户确认":
                    cls = "status-E21010";
                break;
                case "已确认":
                    cls = "status-0AB2A8";
                break;
                case 1:
                    cls = "status-0AB2A8";
                break;
                case 0:
                    cls = "status-B1B1B1";
                break;
            }
            return cls;
        },
        // 对账周期
        periodTimeChange (obj) {
            if (obj) {
                this.formSearch.periodTimeQueryFrom = obj[0]
                this.formSearch.periodTimeQueryTo = obj[1]
            } else {
                this.formSearch.periodTimeQueryFrom = ''
                this.formSearch.periodTimeQueryTo = ''
            }
        },
        searchForm (pages) {
            if (pages) {
                this.pages.currentPage = pages.currentPage
                this.pages.pageSize = pages.pageSize
            }
            let params = Object.assign({}, { data: this.formSearch }, { pageNum: this.pages.currentPage, pageSize: this.pages.pageSize })
            this.isloading = true
            this.$post('/sms/client/arAccounts/list', params).then(({ data }) => {
                if (data && data.code === 'C0000') {
                    this.tableData = data.result.list
                    this.pages.total = data.result.total
                    this.tabs.forEach((e)=>{
                        if(e.state == '0'){
                            e.value = data.extra? data.extra.unRead : ''
                        }
                    })
                }
            }).finally(() => {
                this.isloading = false
            })
        },
        //清除
        resetForm () {
            this.formSearch = {}
            this.customsData = []
        },
        getDetail(row){
            this.$router.push({
                path:'service-bill-detail',
                query: {
                    id: row.id
                }
            })
        },
        //下拉框数据
        getChange(){
            this.$get('/sms/client/arAccounts/typeList').then(({ data }) => {
                if (data && data.code === 'C0000') {
                    this.options = data.result
                }
            })
        },
        selectionChange(val){
            this.selectList = val
        },
        //导出
        derive(){
            this.btnLoading = true
            let excelField = this.columns.map(e => e.props)
            this.$post(`/sms/client/arAccounts/exportList`, { data: this.formSearch, excelField: excelField }).then(({ data }) => {
                if (data && data.code === 'C0000') {
                    this.windowOpenFile(data.result)
                } else {
                    this.$message.error(data.message)
                }
            }).finally(() => {
                this.btnLoading = false
            })
        },  
        //打印
        exportFile () {
            this.exportLoading = true
            this.$get(`/sms/client/arAccounts/pdfByLogisticsByYxClient`, { id: this.selectList[0].id }).then(({ data }) => {
                if (data && data.code === 'C0000') {
                    this.windowOpenFile(data.result)
                } else {
                    this.$message.error(data.message)
                }
            }).finally(() => {
                this.exportLoading = false
            })
        },
        windowOpenFile (url) {
            // 创建隐藏的可下载链接
            var eleLink = document.createElement('a')
            eleLink.download = ''
            eleLink.target = '_blank'
            eleLink.style.display = 'none'
            // 字符内容转变成blob地址
            eleLink.href = url
            // 触发点击
            document.body.appendChild(eleLink)
            eleLink.click()
            // 然后移除
            document.body.removeChild(eleLink)
        },
    },
}
</script>

<style lang="scss">
    .service-bill-list{
        .el-table__body-wrapper{        
            .el-table__body{
                .el-button.el-button--text.is-link.el-tooltip__trigger{
                    margin: 3px 30px 0px 0px !important;
                }
            }
        }
    }
</style>